import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { api, endpoints } from '../../api';
import LkFooterComponent from '../../components/LkFooterComponent';
import { BlueLayout, CustomTableContainer, FormInput, FormItem, MainpageComponentContainer } from '../../styles/styled';
import { PublishersType, PublisherType } from '../NewApplicationPage/types';
import { PaginationType } from '../TextbooksPage/types';

type PublisherTableType = PublisherType & {
  key: number;
};

type PublishersTableType = PublisherTableType[];

export const ListOfOrganisationsPage = () => {
  const [publishersState, setPublishers] = useState<PublishersTableType>([]);
  const [searchInputState, setSearchInput] = useState<string>('');
  const [paginationState, setPagination] = useState<PaginationType>({ pagination: 1, perPage: 10, total: 0 });

  useEffect(() => {
    (async () => {
      try {
        const response = await api.get<PublishersType>(endpoints.getPublicPublishers(0, 10000));

        setPagination({ ...paginationState, total: response.data.length });

        setPublishers(
          response.data.map((el, key) => {
            return { ...el, key: key };
          }),
        );
      } catch (err) {}
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const organisationsColumns = [
    {
      title: 'Наименование',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Адрес местонахождения организации',
      dataIndex: 'address',
      key: 'address',
    },
    {
      title: 'Контактные телефоны',
      dataIndex: 'phone',
      key: 'phone',
    },
    {
      title: 'Адрес электронной почты',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Официальный сайт организации',
      dataIndex: 'web_site',
      key: 'web_site',
    },
  ];

  return (
    <MainpageComponentContainer>
      <BlueLayout>
        Перечень организаций, осуществляющих выпуск учебных пособий, которые допускаются к использованию при реализации
        имеющих государственную аккредитацию образовательных программ начального общего, основного общего, среднего
        общего образования
      </BlueLayout>

      <FormItem>
        <div className="dark-text">Поиск по названию</div>
        <FormInput onChange={(e) => setSearchInput(e.target.value)} value={searchInputState} />
      </FormItem>
      <CustomTableContainer>
        <Table
          columns={organisationsColumns}
          pagination={
            publishersState.filter((el) => el.title.toLowerCase().includes(searchInputState.toLowerCase())).length > 10
              ? {
                  total: publishersState.length,
                  showSizeChanger: true,
                  current: paginationState.pagination,
                  pageSize: paginationState.perPage,
                  pageSizeOptions: [10, 50, 100],
                  onChange: (value, pageSize) =>
                    setPagination({ ...paginationState, perPage: pageSize, pagination: value }),
                }
              : false
          }
          dataSource={
            publishersState
              ? publishersState.filter((el) => el.title.toLowerCase().includes(searchInputState.toLowerCase()))
              : []
          }
        />
      </CustomTableContainer>
      <LkFooterComponent />
    </MainpageComponentContainer>
  );
};
